import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { FUEL_CARD_AND_EXPENSES_FLAG } from '~/common/models/featureFlags.model';
import AccountDetailsCard from '~/features/integrations/manage/AccountDetailsCard';
import DataSharedCard from '~/features/integrations/manage/DataSharedCard';
import EnrollmentOverview from '~/features/integrations/manage/EnrollmentOverview';

import { PARTNER_DEFAULTS } from '../defaults';
import { ENROLLMENT_VIEWS, PARTNER_IDS, type PartnerConfig } from '../types';
import CoastConnectStep from './CoastConnectStep';
import CoastSettingsCard from './CoastSettingsCard';
import CoastVehicleStep from './vehicleSelection/CoastVehicleStep';

export const coastConfig: PartnerConfig = {
  id: PARTNER_IDS.COAST,
  providerCode: 'COAST',
  flag: FUEL_CARD_AND_EXPENSES_FLAG,
  nameKey: 'integrations:coast.name',
  shortNameKey: 'integrations:account.coastName',
  descriptionKey: 'integrations:coast.description',
  shop: {
    ...PARTNER_DEFAULTS.shop,
    counts: [
      {
        key: ENROLLMENT_VIEWS.ELIGIBLE,
        labelKey: 'integrations:coast.eligibleToEnroll',
        tooltipKey: 'integrations:coast.eligibilityTooltip',
      },
      {
        key: ENROLLMENT_VIEWS.ENROLLED,
        labelKey: 'integrations:coast.enrolled',
      },
    ],
  },
  manage: {
    ...PARTNER_DEFAULTS.manage,
    accountFields: (enrollment, context) =>
      PARTNER_DEFAULTS.manage.accountFields(enrollment, context).map((field) =>
        field.testid === 'subscription'
          ? {
              ...field,
              value: translateText('integrations:coast.subscription'),
            }
          : field
      ),
    enrollmentTiles: [
      ENROLLMENT_VIEWS.ENROLLED,
      ENROLLMENT_VIEWS.ERRORS,
      ENROLLMENT_VIEWS.PENDING,
      ENROLLMENT_VIEWS.ELIGIBLE,
    ],
    dataSharedTooltipKey: 'integrations:coast.dataSharedTooltip',
    tabs: PARTNER_DEFAULTS.manage.tabs.map((tab) =>
      tab.id === 'overview'
        ? {
            ...tab,
            sections: [
              AccountDetailsCard,
              EnrollmentOverview,
              CoastSettingsCard,
              DataSharedCard,
            ],
          }
        : tab
    ),
    dataSharedRows: [
      {
        key: 'vehicleNameModel',
        labelKey: 'integrations:account.manage.dataShared.vehicleNameModel',
      },
      { key: 'vin', labelKey: 'integrations:account.manage.dataShared.vin' },
      {
        key: 'licensePlate',
        labelKey: 'integrations:account.manage.dataShared.licensePlate',
      },
      {
        key: 'providerVehicleId',
        labelKey: 'integrations:coast.dataShared.providerVehicleId',
      },
      {
        key: 'location',
        labelKey: 'integrations:account.manage.dataShared.location',
      },
      {
        key: 'odometer',
        labelKey: 'integrations:account.manage.dataShared.odometerTimestamp',
      },
      {
        key: 'fuelLevel',
        labelKey: 'integrations:account.manage.dataShared.fuelLevel',
      },
      {
        key: 'fuelConsumption',
        labelKey: 'integrations:account.manage.dataShared.fuelConsumption',
      },
    ],
    unlinkConfirmBodyKey: 'integrations:coast.unlinkConfirmBody',
  },
  wizard: {
    titleKey: 'integrations:coast.wizardTitle',
    steps: [
      {
        id: 'confirmAccount',
        labelKey: 'integrations:coast.connectFuelCard',
        component: CoastConnectStep,
      },
      {
        id: 'selectVehicles',
        labelKey: 'integrations:coast.enrollVehicles',
        component: CoastVehicleStep,
      },
    ],
  },
};
